<template>
  <div>
    <b-form-group label="K8s Cluster Type" label-for="k8sClusterType">
      <b-form-select id="k8sClusterType" v-model="resource.k8sClusterType" :options="k8sClusterTypes" required></b-form-select>
    </b-form-group>
    <b-form-group v-if="resource.k8sClusterType === 'aws_eks'" label="Authentication Method">
      <b-form-select v-model="resource.authMethod" :options="authMethods" required></b-form-select>
    </b-form-group>
    <b-row v-if="resource.k8sClusterType === 'aws_eks' && resource.authMethod === 'instance-profile'">
      <b-col cols="6">
        <b-form-group label="Region" label-for="region">
          <b-form-input id="region" v-model="resource.region" required></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Cluster Name" label-for="clusterName">
          <b-form-input id="clusterName" v-model="resource.clusterName" required></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group v-if="resource.k8sClusterType === 'aws_eks' && resource.authMethod === 'kubeconfig'" label="K8s Kubeconfig">
      <b-form-textarea id="k8sKubeconfig" v-model="resource.k8sRole" rows="6" required placeholder="Paste Kubernetes Kubeconfig YAML"></b-form-textarea>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: ['resource'],
  data() {
    return {
      k8sClusterTypes: [
        { value: 'aws_eks', text: 'AWS EKS' },
        { value: 'any', text: 'Others' },
      ],
      authMethods: [
        { value: 'instance-profile', text: 'Instance Profile' },
        { value: 'kubeconfig', text: 'Provide Kubeconfig' },
      ],
    };
  },
};
</script>
